<ng-template #template>
  <ng-container *ngIf="isDisplayed">
    <div class="l-mybooking__option-item">
      <asw-next-action-item
        (clickNextAction)="onClick()"
        [canBeClicked]="canBeClicked && canBeClickedNext"
        [title]="guideLabel | staticMsg"
        [titleAria]="guideLabelReader | staticMsg"
        itemId="ticketing"
      >
        <!-- 支払総額 -->
        <ng-container *ngIf="displayTotalAmount">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="'label.paymentTotalAmount2' | staticMsg"
            [content]="totalAmount"
            [contentClass]="displayHighlightedTotalAmount"
          ></asw-next-action-item-content>
        </ng-container>

        <!-- マイル -->
        <ng-container *ngIf="displayMiles">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="'label.requiredMileage1' | staticMsg"
            [content]="miles"
          ></asw-next-action-item-content>
        </ng-container>

        <!-- 税金 -->
        <ng-container *ngIf="displayTax">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="'label.taxFare' | staticMsg"
            [content]="tax"
          ></asw-next-action-item-content>
        </ng-container>

        <!-- 発券期限 -->
        <ng-container *ngIf="displayTicketingDeadline">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="expirationLabel | staticMsg"
            [content]="ticketingDeadline"
          ></asw-next-action-item-content>
        </ng-container>

        <!-- TODO: WAIT FOR DD UPDATE -->
        <!-- <asw-next-action-item-content-attention
        *aswNextActionItemContentAttention
        [canBeClicked]="canBeClicked"
        attentionMessage="Ticketing deadline is approaching."
      ></asw-next-action-item-content-attention> -->
      </asw-next-action-item>
    </div>
  </ng-container>
</ng-template>
